import { getFeature } from "@/FeatureFlag";
import { AccountMetadata, LocalStorageProject } from "@/reducers/environments";
import { LoadedDestinationInfo } from "@/types/global";
import {
  areAllRequiredPropertiesAllowed,
  getPropertyGroupMetadata,
  PropertyGroup,
} from "../DestinationPropertyMetadata";
import { RequestableSaasDestination, SaaSDestination } from "../destinations";

type CurrentProject =
  | { loaded: false }
  | ({ loaded: true } & LocalStorageProject);

export function checkRequiredPropertiesAreAllowed(
  isHipaaV2: boolean,
  project: CurrentProject,
  accountMetadata: AccountMetadata,
  configuredDestination: LoadedDestinationInfo,
  saasDestination?: SaaSDestination | RequestableSaasDestination,
) {
  // Only HIPAA v2 accounts have required properties from an allowlist POV.
  if (!isHipaaV2) {
    return true;
  }

  // Nothing to do if we can't properly look up the destination's metadata.
  if (!saasDestination) {
    return true;
  }

  // Only server-side destinations have required properties since we can't
  // enforce anything if the destination is strictly client-side.
  if (!saasDestination.supportsServerSide) {
    return true;
  }

  // If the account metadata or current project is not loaded, we can't perform
  // the actual check, so we return true to avoid blocking the UI.
  if (!project.loaded) {
    return true;
  }

  const propertyMetadataList = getPropertyGroupMetadata(
    saasDestination.key,
    PropertyGroup.Required,
  );

  if (propertyMetadataList.length === 0) {
    return true;
  }

  const hasPhoneNumberAudiences = getFeature(
    accountMetadata,
    "phoneNumberAudiences",
  );

  const excludedIdentifiers = hasPhoneNumberAudiences ? [] : ["phone"];

  return areAllRequiredPropertiesAllowed(
    accountMetadata,
    project,
    configuredDestination,
    excludedIdentifiers,
  );
}
